export const SwitchField = ({ title, id, name, model, onChange } = {}) =>
  <div className="custom-control custom-switch mt-2">
    <input type="checkbox" className="custom-control-input" id={id} name={name} checked={model[name]} onChange={onChange} />
    <label className="custom-control-label park-description event-information-detail" htmlFor={id}>{title}</label>
  </div>
